<template>
  <div class="birth-year-page">
    <!-- Header Section -->
    <AppHeader 
      header-text="Drivers in your state can save up to $600/year"
      button-text="FREE CALL"
    />

    <!-- Progress Bar -->
    <div class="progress-container">
      <div class="progress-bar">
        <div class="progress-fill"></div>
      </div>
    </div>

    <!-- Navigation -->
    <div class="navigation">
      <div class="container">
        <button class="back-btn" @click="goBack">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          Previous Question
        </button>
      </div>
    </div>

    <!-- Birth Year Section -->
    <section class="birth-year-section">
      <div class="container">
        <div class="birth-year-content">
          <PageTitle title="Birth Year" />
          
          <div class="years-grid">
            <button 
              v-for="year in availableYears" 
              :key="year"
              :class="['year-button', { 'selected': selectedYear === year }]"
              @click="selectYear(year)"
            >
              {{ year }}
            </button>
          </div>
        </div>
      </div>
    </section>

    <!-- Footer Links -->
    <AppFooter />
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue'
import AppFooter from '@/components/AppFooter.vue'
import PageTitle from '@/components/PageTitle.vue'
import { submitDataAndLog } from '@/utils/localStorage'

export default {
  name: 'BirthYearPage',
  components: {
    AppHeader,
    AppFooter,
    PageTitle
  },
  data() {
    return {
      selectedYear: null,
      userQuoteData: null,
      availableYears: []
    }
  },
  mounted() {
    this.loadUserData()
    this.generateYears()
  },
  methods: {
    loadUserData() {
      const storedData = localStorage.getItem('quoteData')
      if (storedData) {
        try {
          this.userQuoteData = JSON.parse(storedData)
          // 检查是否有选择的月份和日期
          if (!this.userQuoteData.birth_month || !this.userQuoteData.birth_day) {
            // 如果没有选择月份或日期，跳转回相应页面
            this.$router.push('/birth-month')
            return
          }
          // 加载之前选择的出生年份（如果有的话）
          if (this.userQuoteData.birth_year !== undefined) {
            this.selectedYear = this.userQuoteData.birth_year
          }
        } catch (error) {
          console.error('Error parsing stored data:', error)
          this.$router.push('/')
        }
      } else {
        // 如果没有数据，跳转回首页
        this.$router.push('/')
      }
    },
    
    saveUserData() {
      localStorage.setItem('quoteData', JSON.stringify(this.userQuoteData))
    },
    
    generateYears() {
      // 生成从1930年到2012年的年份，倒序排列
      const startYear = 1930
      const endYear = 2012
      this.availableYears = []
      
      for (let year = endYear; year >= startYear; year--) {
        this.availableYears.push(year)
      }
    },
    
    async selectYear(year) {
      this.selectedYear = year
      
      // 检查是否是添加驾驶员模式
      if (this.userQuoteData.adding_driver && this.userQuoteData.temp_driver) {
        // 添加驾驶员模式：处理临时驾驶员数据
        this.userQuoteData.temp_driver.birth_year = year
        
        // 合并日期为 月/日/年 格式
        const day = String(this.userQuoteData.temp_driver.birth_day).padStart(2, '0')
        const month = String(this.userQuoteData.temp_driver.birth_month).padStart(2, '0')
        const formattedBirthday = `${month}/${day}/${year}`
        
        // 存储合并后的生日格式到临时驾驶员
        this.userQuoteData.temp_driver.birthday = formattedBirthday
        
        console.log('Additional driver birth year:', year)
        console.log('Additional driver formatted birthday:', formattedBirthday)
        
        this.saveUserData()
        
        // 跳转到Name页面让用户输入姓名和关系
        this.$router.push('/name')
      } else {
        // 主驾驶员模式：处理主驾驶员数据
        this.userQuoteData.birth_year = year
        
        // 合并日期为 月/日/年 格式
        const day = String(this.userQuoteData.birth_day).padStart(2, '0')
        const month = String(this.userQuoteData.birth_month).padStart(2, '0')
        const formattedBirthday = `${month}/${day}/${year}`
        
        // 存储合并后的生日格式
        this.userQuoteData.birthday = formattedBirthday
        
        this.saveUserData()
        
        console.log('Primary driver birth year:', year)
        console.log('Primary driver formatted birthday:', formattedBirthday)
        
        // 提交数据并记录页面提交事件
        await submitDataAndLog('birthyear')
        // 跳转到事故记录页面
        this.$router.push('/incidents')
      }
    },
    
    goBack() {
      this.$router.push('/birth-day')
    }
  }
}
</script>

<style scoped>
/* Page Layout */
.birth-year-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}


/* Navigation */
.navigation {
  padding: 1rem 0;
}

.back-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: none;
  border: none;
  color: #999;
  font-size: 0.9rem;
  cursor: pointer;
  transition: color 0.3s ease;
}

.back-btn:hover {
  color: #666;
}

/* Birth Year Section */
.birth-year-section {
  padding: 2rem 0 4rem;
  background: #fff;
  flex: 1;
}

.birth-year-content {
  text-align: center;
  max-width: 1000px;
  margin: 0 auto;
}

.years-grid {
  display: grid;
  grid-template-columns: repeat(9, 1fr);
  gap: 0.8rem;
  margin-bottom: 2rem;
}

.year-button {
  padding: 0.8rem 0.5rem;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  background: #fff;
  color: #007bff;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  min-height: 55px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.year-button:hover {
  border-color: #007bff;
  background: #f8f9fa;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,123,255,0.15);
}

.year-button.selected {
  border-color: #007bff;
  background: #007bff;
  color: #fff;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,123,255,0.3);
}

/* Responsive Design */
@media (max-width: 768px) {
  .birth-year-content {
    padding: 0 1rem;
  }

  .years-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 0.8rem;
  }

  .year-button {
    padding: 1rem;
    font-size: 0.9rem;
    min-height: 60px;
  }

  .birth-year-section {
    padding: 1.5rem 0 2rem;
  }
}

@media (max-width: 480px) {
  .years-grid {
    gap: 0.6rem;
  }

  .year-button {
    padding: 0.9rem;
    font-size: 0.85rem;
    min-height: 55px;
  }

  .birth-year-section {
    padding: 1rem 0;
  }
}
</style>
